import React from 'react';
import { ProgressChartData } from '../../../Data/Widgets/Chart/ChartData';
import ReactApexChart from 'react-apexcharts';
const ProgressBarChart = (props) => {
  const updatedOption = {
    ...ProgressChartData,
    options: {
      ...ProgressChartData.options,
      fill: {
        ...ProgressChartData.options.fill,
        colors: props.chartData.colors,
        gradient: {
          ...ProgressChartData.options.gradient,
          gradientToColors: props.chartData.colors,
        },
      },
      title: {
        ...ProgressChartData.options.title,
        text: props.chartData.series[0].name,
      },
      subtitle: {
        ...ProgressChartData.options.subtitle,
        text: ` ${props.chartData.series[0].data[0]}%`,
      },
    },
  };

  return (
    <div id={`progress${props.index + 1}`}>
      <ReactApexChart options={updatedOption.options} series={props.chartData.series} height='70' type='bar' />
    </div>
  );
};

export default ProgressBarChart;
